export const Row = (content: string) => `
<mj-section background-color="#ffffff" padding="8px 15px">
  ${content}
</mj-section>
`;
